import { Dispatch, SetStateAction, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { FILTERS } from '@sorare/core/src/lib/filters';

export const useSelectingCardsToDrop = (
  rarityParam: Nullable<Rarity>
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [selectingCardsToDrop, setSelectingCardsToDrop] = useState(false);

  const { items } = useRefinementList({
    attribute: FILTERS.rarity.attribute,
  });
  const refinedItems = items.filter(item => item.isRefined);

  const selectedRarity =
    rarityParam ??
    (refinedItems.length === 1 ? refinedItems[0].value : undefined);

  if (selectedRarity !== Rarity.common && selectingCardsToDrop) {
    setSelectingCardsToDrop(false);
  }

  return [selectingCardsToDrop, setSelectingCardsToDrop];
};
